import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

/**
 * breadcrumb 当前页面是否显示面包屑
 */
export default new Router({
  mode: 'history',
  base: 'shop/',
  routes: [
    {
      path: '/',
      name: 'main',
      redirect: '/home',
      meta: { crumbtitle: '首页' },
      component: () =>
        import(/* webpackChunkName: "lifeIndex" */ '../views/index.vue'),
      children: [
        {
          path: '/home',
          name: 'lifeIndex',
          meta: { breadcrumb: false, title: '优选生活 - 首页', crumbtitle: '首页' },
          component: () =>
            import(/* webpackChunkName: "lifeIndex" */ '../views/lifeIndex/index.vue'),
        },
        {
          path: '/shopping/cart',
          name: 'shoppingCart',
          meta: { title: '优选生活 - 购物车' },
          component: () =>
            import(/* webpackChunkName: "shoppingCart" */ '../views/shopping/index.vue'),
        },
        {
          path: '/add/list',
          name: 'addOnList',
          meta: { title: '优选生活 - 凑单页' },
          component: () =>
            import(/* webpackChunkName: "addOnList" */ '../views/addOnList/index.vue'),
        },
        {
          path: '/product/detail',
          name: 'product/detail',
          meta: { title: '优选生活 - 商品详情页', pageId: 10000034 },
          component: () =>
            import(/* webpackChunkName: "productDetail" */ '../views/product/detail/index.vue'),
        },
        {
          path: '/product/list',
          name: 'productList',
          meta: { title: '优选生活 - 列表页', crumbtitle: '订单列表'},
          component: () =>
            import(/* webpackChunkName: "productList" */ '../views/product/list/index.vue'),
        },
        {
          path: '/user/address',
          name: 'userAddress',
          meta: { title: '优选生活 - 个人中心', crumbtitle: '订单列表'},
          component: () =>
            import(/* webpackChunkName: "userAddress" */ '../views/userAddress/index.vue'),
        },
        {
          path: '/user/secretFree',
          name: 'secretFree',
          meta: { title: '优选生活 - 个人中心', crumbtitle: '支付设置'},
          component: () =>
            import(/* webpackChunkName: "secretFree" */ '../views/userSetting/secretFree/index.vue'),
        },
        {
          path: '/order',
          name: 'order',
          redirect: '/order/list',
          meta: { crumbtitle: '购物订单' },
          component: () =>
            import(/* webpackChunkName: "index" */ '../views/order/index.vue'),
          children: [
            {
              path: '/order/list',
              name: 'OrderList',
              meta: { title: '优选生活 - 购物订单', breadcrumb: true, crumbtitle: '购物订单'},
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderList/index.vue'),
            },
            {
              path: '/order/payPending',
              name: 'payPending',
              meta: { title: '', breadcrumb: true, crumbtitle: ''},
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/pay/payPending.vue'),
            },
            {
              path: '/order/confirm',
              name: 'OrderConfirm',
              meta: { title: '优选生活 - 订单确认', breadcrumb: false, pageId: 10000192 },
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderConfirm/index.vue'),
            },
            {
              path: '/order/confirmNew',
              name: 'OrderConfirmNew',
              meta: { title: '优选生活 - 订单确认', breadcrumb: false, pageId: 10000192 },
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderConfirmNew/index.vue'),
            },
            {
              path: '/order/confirmTest',
              name: 'OrderConfirm',
              meta: { title: '优选生活 - 订单确认', breadcrumb: false, pageId: 10000193 },
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderConfirm/indexTest.vue'),
            },
            {
              path: '/order/detail/:id',
              name: 'OrderDetails',
              meta: { title: '优选生活 - 订单详情', crumbtitle: '订单详情', breadcrumb: true },
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderDetails/index.vue'),
            },
            {
              path: '/order/logistics/list/:id',
              name: 'logisticsList',
              meta: { title: '优选生活 - 物流信息', breadcrumb: true, crumbtitle: '物流信息' },
              component: () => import(/* webpackChunkName: "index" */'../views/order/logistics/List/index.vue'),
            },
            {
              path: '/order/payStatus',
              name: 'OrderPayStatus',
              meta: { title: '优选生活 - 支付状态', breadcrumb: false, pageId: 10000195 },
              component: () =>
                import(/* webpackChunkName: "index" */ '../views/order/OrderPayStatus/index.vue'),
            }
            
          ],
        }
      ],
    },
    {
      path: '/birthday',
      name: 'birthday',
      meta: { breadcrumb: false, title: '生日汇' },
      component: () =>
        import(/* webpackChunkName: "birthday" */ '../views/birthday/index.vue'),
    },
    {
      path: '/brand/detail/:brandId',
      name: 'brandDetail',
      meta: { breadcrumb: false, title: '生日汇 - 详情页' },
      component: () =>
        import(/* webpackChunkName: "brandDetail" */ '../views/brandDetail/index.vue'),
    },
    {
      path: '/brand/newDetail/:brandId',
      name: 'newBrandDetail',
      meta: { breadcrumb: false, title: '生日汇 - 详情页' },
      component: () =>
        import(/* webpackChunkName: "brandDetail" */ '../views/newBrandDetail/index.vue'),
    },
    {
      path: '/activity/detail/:id',
      name: 'ActivityDetail',
      meta: { title: ''},
      component: () =>
        import(/* webpackChunkName: "productList" */ '../views/activity/index.vue'),
    },
    {
      path: '/book',
      name: 'book',
      meta: { breadcrumb: false, title: '图书' },
      component: () =>
          import(/* webpackChunkName: "BookIndex" */ '../views/book/index.vue'),
    },
    {
      path: '/JDLife',
      name: 'JDLife',
      meta: { breadcrumb: false, title: '京东优选' },
      component: () =>
          import(/* webpackChunkName: "JDLife" */ '../views/JDLife/index.vue'),
    },
    {
      path: '/product/JDList',
      name: 'product/JDList',
      meta: { breadcrumb: false, title: '京东优选 - 列表页', crumbtitle: '订单列表'},
      component: () =>
        import(/* webpackChunkName: "JDList" */ '../views/product/JDList/index.vue'),
    }
  ],
  scrollBehavior() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});
